export default __webpack_public_path__ + "static/media/ognsearchbanner.100b9af5.jpg";